import { FC, useState } from 'react';
import { Grid, Tabs, Tab, Box } from '@mui/material';
import { useGuardianState } from '../../contexts/guardian.context';
import { useTranslation } from 'src/hooks/useTranslationHook';
import GuardianProfileInfoTab from './components/GuardianProfileInfoTab.component';
import GuardianProfileDocumentsTab from './components/GuardianProfileDocumentsTab.component';

const GuardianProfileView: FC = () => {
  const { translateText } = useTranslation();
  const { selectedChildId } = useGuardianState();
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Grid container spacing={3} sx={{ p: 3 }} data-testid="guardian-profile-container">
      <Grid item xs={12}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label={translateText('guardian.profile.tabs.label')}
            data-testid="guardian-profile-tabs"
          >
            <Tab
              label={translateText('guardian.profile.tabs.info')}
              data-testid="guardian-profile-tab-info"
            />
            <Tab
              label={translateText('guardian.profile.tabs.documents')}
              data-testid="guardian-profile-tab-documents"
            />
          </Tabs>
        </Box>
      </Grid>

      <Grid item xs={12}>
        {activeTab === 0 && (
          <GuardianProfileInfoTab studentId={selectedChildId || ''} />
        )}
        {activeTab === 1 && (
          <GuardianProfileDocumentsTab studentId={selectedChildId || ''} />
        )}
      </Grid>
    </Grid>
  );
};

export default GuardianProfileView;
